"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOdd = void 0;
function isOdd(n) {
    return (n & 1) === 1;
}
exports.isOdd = isOdd;
//# sourceMappingURL=isOdd.js.map